import {PaginatedData} from "@/core/interfaces/api";
import {ObjectSchema, ObjectValue} from "@/generated-report/interfaces";
import {AxiosInstance} from "axios";
import {ConsumerBackingReport, ConsumerBackingReportType} from "@/backing/interfaces/backing";

export interface ConsumerReportsIndexRequest {
    page?: number;
    limit?: number;
    type?: ConsumerBackingReportType;
}

export interface ReportResponseWithSchema {
    data: ConsumerBackingReport;
    schema: ObjectSchema;
}

export interface CreateConsumerBackingReportRequest {
    type: ConsumerBackingReportType;
}


export default function (apiClient: AxiosInstance, hdsClient: AxiosInstance) {
    return {
        /**
         * Get the consumer reports for a given backings.
         */
        async indexConsumerReports(
            consumerKey: string,
            backingId: number,
            params: ConsumerReportsIndexRequest = {}
        ): Promise<PaginatedData<ConsumerBackingReport[]>> {
            return apiClient.get(`/consumers/${consumerKey}/backings/${backingId}/reports`, {params})
                .then((response) => response.data);
        },

        /**
         * Get a specific consumer report for a given backing.
         */
        async readConsumerReport(consumerKey: string, backingId: number, reportId: number): Promise<ReportResponseWithSchema> {
            return apiClient.get(`/consumers/${consumerKey}/backings/${backingId}/reports/${reportId}`)
                .then((response) => response.data);
        },

        /**
         * Create a new consumer report for a given backing.
         */
        async createConsumerReport(
            consumerKey: string,
            backingId: number,
            data: CreateConsumerBackingReportRequest
        ): Promise<ReportResponseWithSchema> {
            return hdsClient.post(`/consumers/${consumerKey}/backings/${backingId}/reports`, {data})
                .then((response) => response.data);
        },

        /**
         * Update an existing consumer report for a given backing.
         */
        async updateConsumerReport(backingId: number, consumerKey: string, reportId: number, editedContent: ObjectValue) {
            return apiClient.patch(`/consumers/${consumerKey}/backings/${backingId}/reports/${reportId}`, {
                edited_content: editedContent
            }).then((response) => response.data);
        },

        /**
         * Download a specific consumer report for a given backing.
         */
        async download(backingId: number, consumerKey: string, reportId: number): Promise<Blob> {
            return apiClient.get(`/consumers/${consumerKey}/backings/${backingId}/reports/${reportId}/download`, {
                responseType: 'blob'
            }).then((response) => {
                return response.data;
            });
        }
    };
}
